import { Component, OnInit } from '@angular/core';
import { UserInfoService } from 'src/app/core/services/user-info.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.scss']
})
export class LogoutPageComponent implements OnInit {

  constructor(private _userService: UserInfoService) { }

  ngOnInit() {
    window.location.href = environment.guardLogoutUrl;
  }

}
